
import { useEmergencyOptimizedExerciseQuery } from "./hooks/useEmergencyOptimizedExerciseQuery";
import { useEmergencyUpdateQueue } from "./hooks/useEmergencyUpdateQueue";
import { EmergencyExerciseItem } from "./EmergencyExerciseItem";
import { RoutineShimmer } from "../RoutineShimmer";

interface EmergencyExerciseListProps {
  routineId: string;
}

export const EmergencyExerciseList = ({ routineId }: EmergencyExerciseListProps) => {
  const {
    data: exercises,
    isLoading,
    error
  } = useEmergencyOptimizedExerciseQuery({
    routineId,
    enabled: !!routineId
  });

  const { queueUpdate, getPendingCount } = useEmergencyUpdateQueue(routineId);
  const pendingCount = getPendingCount();

  console.log(`🚨 EMERGENCY: Exercise list - ${exercises?.length || 0} exercises, ${pendingCount} pending updates`);

  if (error) {
    return (
      <div className="text-center py-8">
        <div className="text-red-500 mb-2">⚠️ Error de conexión</div>
        <div className="text-sm text-gray-600">
          No se pudieron cargar los ejercicios. Verifica tu conexión.
        </div>
      </div>
    );
  }

  if (isLoading) {
    return <RoutineShimmer />;
  }

  if (!exercises || exercises.length === 0) {
    return (
      <div className="text-center py-8">
        <div className="text-gray-500">No hay ejercicios en esta rutina</div>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {pendingCount > 0 && (
        <div className="bg-yellow-500/20 border border-yellow-500/50 rounded-lg p-3">
          <div className="text-sm text-yellow-800 dark:text-yellow-200">
            🚨 Modo de emergencia activo - {pendingCount} cambios pendientes de sincronización
          </div>
        </div>
      )}
      
      {exercises.map((exercise) => (
        <EmergencyExerciseItem
          key={exercise.id}
          exercise={exercise}
          onUpdate={queueUpdate}
          routineId={routineId}
        />
      ))}
    </div>
  );
};
